<script setup lang="ts">
import type { OAuthCredential } from 'firebase/auth'

interface IEmits {
  (e: 'signIn', data: OAuthCredential | false): void
}

const emit = defineEmits<IEmits>()

const { colors } = useTheme()

async function googleSignIn() {
  const { logIn } = useFirebaseAuth()
  const result = await logIn()
  if (result)
    emit('signIn', result)
}
</script>

<template>
  <button
    min-12 w-full max-w="273px" p-2
    flex items-center gap-4
    border="1 [#C3C8CF]" rounded
    @click="googleSignIn"
  >
    <div i-logos:google-icon w-5 />
    <Text :color="colors.softBlack">
      Continue with Google
    </Text>
  </button>
</template>
